import { AHIcon, AHText, Circle, useLayoutContext } from "arkh";
import React, { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { PopoverList, PopoverListItem } from "../../components/mobile/Popover";

import { StorecastPickerPopoverItem_dashboard$key } from "./__generated__/StorecastPickerPopoverItem_dashboard.graphql";

import { StorecastPickerPopoverDashboards$key } from "./__generated__/StorecastPickerPopoverDashboards.graphql";

function StorecastPickerItem(props: {
  onClose(): void;
  isCurrentDashboard: boolean;
  dashboard: StorecastPickerPopoverItem_dashboard$key;
  onPress(item: { id: string }): void;
}) {
  const dashboard = useFragment(
    graphql`
      fragment StorecastPickerPopoverItem_dashboard on Dashboard {
        id
        name
      }
    `,
    props.dashboard
  );
  const onPress = useCallback(() => {
    props.onPress({ id: dashboard.id });
    props.onClose();
  }, [dashboard.id, props]);
  return (
    <PopoverListItem selected={props.isCurrentDashboard} onPress={onPress}>
      <Circle color="surface-backgroundControl" size="smallMedium">
        <AHIcon type="dashboard" color="text-primary" size="small" />
      </Circle>
      <AHText type="title-small" spaceLeft="small" style={{ flex: 1 }}>
        {dashboard.name}
      </AHText>
    </PopoverListItem>
  );
}

function keyExtractor(item: { id: string }) {
  return item.id;
}

export function StorecastPickerPopover(props: {
  onClose(): void;
  dashboards: StorecastPickerPopoverDashboards$key;
  currentDashboardId?: string;
  onSelectItem(item: { id: string }): void;
}) {
  const dashboards = useFragment(
    graphql`
      fragment StorecastPickerPopoverDashboards on Dashboard
      @relay(plural: true) {
        id
        ...StorecastPickerPopoverItem_dashboard
      }
    `,
    props.dashboards
  );

  const layout = useLayoutContext();

  const renderItem = useCallback(
    ({ item }: { item: (typeof dashboards)[number] }) => (
      <StorecastPickerItem
        isCurrentDashboard={props.currentDashboardId === item.id}
        dashboard={item}
        onPress={props.onSelectItem}
        onClose={props.onClose}
      />
    ),
    [props.onClose, props.onSelectItem, props.currentDashboardId]
  );

  return (
    <PopoverList
      data={dashboards}
      scrollIndicatorInsets={{
        top: layout.space.medium,
        bottom: layout.space.medium,
      }}
      renderItem={renderItem}
      keyExtractor={keyExtractor}
    />
  );
}
